import React, { useState } from 'react';
import { 
  FaHome, 
  FaCalendar, 
  FaClock, 
  FaUser,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaCheckCircle,
  FaArrowRight,
  FaStar,
  FaTruck,
  FaEye,
  FaRupeeSign
} from 'react-icons/fa';

const TryAtHomePage = () => {
  const [step, setStep] = useState(1);
  const [bookingData, setBookingData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    date: '',
    time: '',
    frames: []
  });

  const timeSlots = [
    '10:00 AM - 11:00 AM',
    '11:00 AM - 12:00 PM',
    '12:00 PM - 1:00 PM',
    '2:00 PM - 3:00 PM',
    '3:00 PM - 4:00 PM',
    '4:00 PM - 5:00 PM',
    '5:00 PM - 6:00 PM',
    '6:00 PM - 7:00 PM'
  ];

  const sampleFrames = [
    {
      id: 1,
      name: 'Vincent Chase',
      image: 'https://img.freepik.com/premium-photo/black-frame-eyeglasses-unisex-isolated-white-background_727279-100.jpg?w=200',
      price: 2999
    },
    {
      id: 2,
      name: 'John Jacobs',
      image: 'https://static.vecteezy.com/system/resources/previews/020/221/634/large_2x/1092-black-eyeglasses-isolated-on-a-transparent-background-photo.jpg',
      price: 3999
    },
    {
      id: 3,
      name: 'Hustlr',
      image: 'https://tse3.mm.bing.net/th/id/OIP.wWdDbR3XF5azr0hSmzBASQHaHa?w=1920&h=1920&rs=1&pid=ImgDetMain&o=7&rm=3',
      price: 2499
    }
  ];

  const features = [
    {
      icon: <FaTruck className="text-3xl" />,
      title: 'Free Home Trial',
      description: 'Try 5 frames at home for free'
    },
    {
      icon: <FaEye className="text-3xl" />,
      title: 'Expert Consultation',
      description: 'Get advice from eyewear specialists'
    },
    {
      icon: <FaClock className="text-3xl" />,
      title: 'Flexible Timing',
      description: 'Choose your preferred time slot'
    },
    {
      icon: <FaCheckCircle className="text-3xl" />,
      title: 'Hassle-free Returns',
      description: 'Easy returns if not satisfied'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-gradient-to-r from-orange-500 to-pink-500 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <FaHome className="text-5xl mx-auto mb-4 animate-bounce" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Try @ Home Service</h1>
          <p className="text-xl text-orange-100 max-w-2xl mx-auto">
            Get 5 frames delivered to your home for a free trial
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {features.map((feature, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300">
              <div className="text-orange-500 mb-4">{feature.icon}</div>
              <h3 className="font-semibold text-lg text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-500">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
          <div className="grid lg:grid-cols-2">
            <div className="p-8 bg-gradient-to-br from-orange-50 to-pink-50">
              <h2 className="text-2xl font-bold text-gray-800 mb-6">Book Your Free Trial</h2>
              <div className="space-y-4">
                <div className={`flex items-center gap-4 p-4 rounded-xl ${step >= 1 ? 'bg-white shadow-md' : ''}`}>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold ${
                    step > 1 ? 'bg-green-500 text-white' : step === 1 ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-500'
                  }`}>
                    {step > 1 ? <FaCheckCircle /> : '1'}
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Personal Details</h3>
                    <p className="text-sm text-gray-500">Your name and contact information</p>
                  </div>
                </div>
                <div className={`flex items-center gap-4 p-4 rounded-xl ${step >= 2 ? 'bg-white shadow-md' : ''}`}>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold ${
                    step > 2 ? 'bg-green-500 text-white' : step === 2 ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-500'
                  }`}>
                    {step > 2 ? <FaCheckCircle /> : '2'}
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Address & Schedule</h3>
                    <p className="text-sm text-gray-500">Where and when to deliver</p>
                  </div>
                </div>
                <div className={`flex items-center gap-4 p-4 rounded-xl ${step >= 3 ? 'bg-white shadow-md' : ''}`}>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold ${
                    step > 3 ? 'bg-green-500 text-white' : step === 3 ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-500'
                  }`}>
                    {step > 3 ? <FaCheckCircle /> : '3'}
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Select Frames</h3>
                    <p className="text-sm text-gray-500">Choose up to 5 frames to try</p>
                  </div>
                </div>
                <div className={`flex items-center gap-4 p-4 rounded-xl ${step >= 4 ? 'bg-white shadow-md' : ''}`}>
                  <div className={`w-8 h-8 rounded-full flex items-center justify-center font-bold ${
                    step > 4 ? 'bg-green-500 text-white' : step === 4 ? 'bg-orange-500 text-white' : 'bg-gray-200 text-gray-500'
                  }`}>
                    '4'
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-800">Confirm & Book</h3>
                    <p className="text-sm text-gray-500">Review and confirm your booking</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-8">
              {step === 1 && (
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Personal Details</h3>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Full Name *</label>
                    <div className="relative">
                      <input
                        type="text"
                        className="w-full px-4 py-3 pl-11 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                        placeholder="John Doe"
                      />
                      <FaUser className="absolute left-4 top-3.5 text-gray-400" />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number *</label>
                    <div className="relative">
                      <input
                        type="tel"
                        className="w-full px-4 py-3 pl-11 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                        placeholder="+91 9709799555"
                      />
                      <FaPhone className="absolute left-4 top-3.5 text-gray-400" />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Email Address</label>
                    <div className="relative">
                      <input
                        type="email"
                        className="w-full px-4 py-3 pl-11 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                        placeholder="john@example.com"
                      />
                      <FaEnvelope className="absolute left-4 top-3.5 text-gray-400" />
                    </div>
                  </div>

                  <button
                    onClick={() => setStep(2)}
                    className="w-full bg-gradient-to-r from-orange-500 to-pink-500 text-white py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-pink-600 transition-all duration-300 mt-4"
                  >
                    Next: Address & Schedule
                  </button>
                </div>
              )}

              {step === 2 && (
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Address & Schedule</h3>
                  
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Address *</label>
                    <div className="relative">
                      <input
                        type="text"
                        className="w-full px-4 py-3 pl-11 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                        placeholder="House/Flat No., Building, Street"
                      />
                      <FaHome className="absolute left-4 top-3.5 text-gray-400" />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">City *</label>
                      <input
                        type="text"
                        className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                        placeholder="Mumbai"
                      />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">Pincode *</label>
                      <input
                        type="text"
                        className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                        placeholder="400070"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Date *</label>
                    <input
                      type="date"
                      className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Select Time Slot *</label>
                    <select className="w-full px-3 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500">
                      <option value="">Choose a time slot</option>
                      {timeSlots.map((slot, i) => (
                        <option key={i} value={slot}>{slot}</option>
                      ))}
                    </select>
                  </div>

                  <div className="flex gap-3">
                    <button
                      onClick={() => setStep(1)}
                      className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-all duration-300"
                    >
                      Back
                    </button>
                    <button
                      onClick={() => setStep(3)}
                      className="flex-1 bg-gradient-to-r from-orange-500 to-pink-500 text-white py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-pink-600 transition-all duration-300"
                    >
                      Next: Select Frames
                    </button>
                  </div>
                </div>
              )}

              {step === 3 && (
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Select Frames (Max 5)</h3>
                  
                  <div className="space-y-3 max-h-96 overflow-y-auto">
                    {sampleFrames.map((frame) => (
                      <div key={frame.id} className="flex items-center gap-3 p-3 border border-gray-200 rounded-lg">
                        <input type="checkbox" className="w-5 h-5 text-orange-500" />
                        <img src={frame.image} alt={frame.name} className="w-16 h-16 object-contain" />
                        <div className="flex-1">
                          <h4 className="font-semibold text-gray-800">{frame.name}</h4>
                          <p className="text-sm text-gray-500 flex items-center">
                            <FaRupeeSign className="text-xs" />
                            {frame.price}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="flex gap-3">
                    <button
                      onClick={() => setStep(2)}
                      className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-all duration-300"
                    >
                      Back
                    </button>
                    <button
                      onClick={() => setStep(4)}
                      className="flex-1 bg-gradient-to-r from-orange-500 to-pink-500 text-white py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-pink-600 transition-all duration-300"
                    >
                      Next: Confirm
                    </button>
                  </div>
                </div>
              )}

              {step === 4 && (
                <div className="space-y-4">
                  <h3 className="text-xl font-bold text-gray-800 mb-4">Confirm Your Booking</h3>
                  
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-center">
                    <FaCheckCircle className="text-green-500 text-4xl mx-auto mb-3" />
                    <h4 className="font-bold text-green-600 mb-1">Almost Done!</h4>
                    <p className="text-sm text-gray-600">Please review your details before confirming</p>
                  </div>

                  <div className="space-y-2">
                    <p className="text-sm"><span className="font-semibold">Name:</span> John Doe</p>
                    <p className="text-sm"><span className="font-semibold">Phone:</span> +91 9709799555</p>
                    <p className="text-sm"><span className="font-semibold">Address:</span> 123, MG Road, Mumbai - 400070</p>
                    <p className="text-sm"><span className="font-semibold">Date:</span> 2024-01-20</p>
                    <p className="text-sm"><span className="font-semibold">Time:</span> 10:00 AM - 11:00 AM</p>
                    <p className="text-sm"><span className="font-semibold">Frames:</span> 3 selected</p>
                  </div>

                  <div className="flex gap-3">
                    <button
                      onClick={() => setStep(3)}
                      className="flex-1 bg-gray-200 text-gray-700 py-3 rounded-lg font-semibold hover:bg-gray-300 transition-all duration-300"
                    >
                      Back
                    </button>
                    <button className="flex-1 bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-lg font-semibold hover:from-green-600 hover:to-green-700 transition-all duration-300">
                      Confirm Booking
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TryAtHomePage;